<template>
<div class="chapter">
<div class="inner_page">
<p class="p6">Pour tous ceux qui ne sont pas parfaits.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?11a42367